import { render, staticRenderFns } from "./active-new.vue?vue&type=template&id=e06135c6"
import script from "./active-new.vue?vue&type=script&lang=js"
export * from "./active-new.vue?vue&type=script&lang=js"
import style0 from "./active-new.vue?vue&type=style&index=0&id=e06135c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports